<template>
  <v-dialog
    v-model="dialog"
    max-width="800px"
  >
    <v-card>
      <v-card-title>
        Подтвердите действие
      </v-card-title>
      <v-card-text>
        {{text}}
      </v-card-text>
      <v-card-actions>
        <v-btn
          @click="approve"
          color="green"
          text
        >
          <v-icon small>{{button_icon}}</v-icon>
          {{button_text}}
        </v-btn>

        <v-btn
          color="red"
          text
          @click="dialog=false"
        >
          <v-icon small>mdi-close</v-icon>
          Отмена
        </v-btn>
      </v-card-actions>
    </v-card>


  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    dialog: false,
    approved: false,
    text: '',
    button_text: '',
    button_icon: ''
  }),
  methods: {
    approve(){
      this.approved = true
      this.dialog = false
    },
    async ask(text, button_text, button_icon) {
      this.approved = false
      this.text = text
      this.button_text = button_text
      this.button_icon = button_icon
      this.dialog = true

      while (this.dialog) {
        await new Promise(r => setTimeout(r, 100))
      }

      return this.approved
    }
  }
}
</script>